export default "__VITE_ASSET__BSsYCo5v__"